import { Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { select, Store } from '@ngrx/store'
import { iif, Observable, of } from 'rxjs'
import { map, switchMap, take } from 'rxjs/operators'
import { LoginService } from '../../../login/shared/login.service'
import * as fromStore from '../../store/selectors'
import { AccountStatus } from '../../account-status.enum'
import { appConfig } from '../../../../brands/_current/config/app-config'

@Injectable({ providedIn: 'root' })
export class UnconfirmedAccountGuard {
  constructor(
    private readonly store: Store,
    private readonly loginService: LoginService,
    private readonly router: Router,
  ) {}

  /**
   * Check if status of account is unconfirmed and manages redirects
   */
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.pipe(
      select(fromStore.getAccountStatus),
      take(1),
      map((accountStatus) => accountStatus === AccountStatus.unconfirmed),
      switchMap((success) => iif(() => success, of(true), this.loginService.backToLogin())),
      map(
        (success) =>
          success || this.router.createUrlTree([appConfig.feedback.paths._root, appConfig.feedback.paths.genericError]),
      ),
    )
  }
}
